import { Injectable } from '@angular/core';
import { isBusinessPortalEnabledForIssuingOrganization } from 'src/app/_config/business-portal.config';
import { OrganizationEnum } from 'src/app/_models/enum/organization-enum';
import { RegionService } from '../region/region.service';

@Injectable({
  providedIn: 'root',
})
export class BusinessPortalFeatureService {
  constructor(private readonly regionService: RegionService) {}

  isEnabledForCurrentMarket(): boolean {
    return isBusinessPortalEnabledForIssuingOrganization(this.regionService.getClientOrganization());
  }

  isEnabledForIssuingOrganization(organizationId: OrganizationEnum | string | null | undefined): boolean {
    return isBusinessPortalEnabledForIssuingOrganization(organizationId);
  }
}
